/* ===========================================================================
   CREMA NIDA — Configuración editable
   Cambia estos valores sin tocar el resto del archivo ni el .liquid.
   =========================================================================== */
window.NIDA_CONFIG = {
  // 'shopify'  -> usa el botón/formulario nativo de Shopify (/cart/add) de esta sección
  // 'releasit' -> oculta el formulario nativo; muestra el bloque de Releasit
  //               que agregues desde el editor visual (Personalizar → esta
  //               sección → "Agregar bloque" → elige el bloque de Releasit).
  CHECKOUT_APP: 'releasit',

  // Contador de tiempo de oferta
  SHOW_COUNTDOWN: true,
  COUNTDOWN_MINUTES: 15,           // se reinicia cada vez que llega a 0
  COUNTDOWN_LABEL: '¡Oferta termina en!',

  // Contador social "personas compraron hoy"
  BUYER_COUNT_START: 3157,
  BUYER_COUNT_LABEL_SUFFIX: 'personas han comprado hoy',

  // Texto de la franja verde animada (marquee)
  MARQUEE_TEXT: '⚠️ VENDEMOS PRODUCTOS AUTÉNTICOS · Compra con tranquilidad',

  // Línea de prueba social sobre los videos
  SOCIAL_PROOF_LINE: 'Más de 8.419 personas han probado este producto'
};
/* =========================================================================== */

(function () {
  document.querySelectorAll('.nida-wrap').forEach(function (wrap) {
    var cfg = window.NIDA_CONFIG || {};

    var tierGrid = wrap.querySelector('[data-unit-price]');
    var tierBtns = wrap.querySelectorAll('.nida-tier-btn');
    var priceSale = wrap.querySelector('.nida-price-sale');
    var priceCompare = wrap.querySelector('.nida-price-compare');
    var discountBadge = wrap.querySelector('.nida-discount-badge');
    var cartBtnPrice = wrap.querySelector('.nida-cart-btn-price');
    var qtyInput = wrap.querySelector('.nida-qty-input');

    function formatMoney(cents) {
      if (window.Shopify && window.Shopify.formatMoney && window.Shopify.money_format) {
        return window.Shopify.formatMoney(cents, window.Shopify.money_format);
      }
      return (cents / 100).toFixed(2);
    }

    // Fill in the sticker/total prices for the 2 & 3 unit tiers on load
    // (single-product qty multiplier, no separate Shopify variants needed).
    if (tierGrid) {
      var unitPrice = parseInt(tierGrid.dataset.unitPrice, 10) || 0;
      var unitCompare = parseInt(tierGrid.dataset.unitCompare, 10) || unitPrice;
      tierBtns.forEach(function (btn) {
        var qty = parseInt(btn.dataset.qty, 10);
        var savings = parseInt(btn.dataset.savings, 10) || 0;
        var sticker = unitCompare * qty;
        var total = Math.round(unitPrice * qty * (1 - savings / 100));
        var stickerEl = btn.querySelector('.nida-tier-sticker');
        var totalEl = btn.querySelector('.nida-tier-total');
        if (stickerEl) stickerEl.textContent = sticker > total ? formatMoney(sticker) : '';
        if (totalEl) totalEl.textContent = formatMoney(total);
        btn.dataset.total = total;
        btn.dataset.compare = sticker;
      });
    }

    tierBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        tierBtns.forEach(function (b) {
          var isActive = b === btn;
          b.classList.toggle('active', isActive);
          var badge = b.querySelector('.nida-tier-badge');
          if (badge) badge.classList.toggle('active', isActive);
        });

        var total = parseInt(btn.dataset.total, 10);
        var compareAt = parseInt(btn.dataset.compare, 10);
        var qty = btn.dataset.qty;

        var totalFormatted = formatMoney(total);
        var compareFormatted = formatMoney(compareAt);

        if (priceSale) priceSale.textContent = totalFormatted;
        if (priceCompare) priceCompare.textContent = compareAt > total ? compareFormatted : '';
        if (cartBtnPrice) cartBtnPrice.textContent = totalFormatted;
        if (qtyInput) qtyInput.value = qty;

        if (discountBadge) {
          if (compareAt > total) {
            var pct = Math.round(((compareAt - total) / compareAt) * 100);
            discountBadge.textContent = '-' + pct + '% PROMO';
            discountBadge.style.display = '';
          } else {
            discountBadge.style.display = 'none';
          }
        }

        document.dispatchEvent(new CustomEvent('nida:quantity-change', { detail: { quantity: qty } }));
      });
    });

    // Show native Shopify form OR the Releasit app-block anchor
    var nativeForm = wrap.querySelector('.nida-cart-form');

    // FAQ accordion
    wrap.querySelectorAll('.nida-faq-toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var answer = btn.parentElement.querySelector('.nida-faq-answer');
        var chevron = btn.querySelector('.nida-faq-chevron');
        answer.classList.toggle('open');
        chevron.classList.toggle('open');
      });
    });

    // Before / after drag slider
    var slider = wrap.querySelector('.nida-before-after');
    if (slider) {
      var clip = slider.querySelector('.nida-ba-clip');
      var handle = slider.querySelector('.nida-ba-handle');
      var dragging = false;
      function update(clientX) {
        var rect = slider.getBoundingClientRect();
        var pct = Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100));
        clip.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
        handle.style.left = pct + '%';
      }
      slider.addEventListener('pointerdown', function (e) { dragging = true; update(e.clientX); });
      slider.addEventListener('pointermove', function (e) { if (dragging) update(e.clientX); });
      window.addEventListener('pointerup', function () { dragging = false; });
      slider.addEventListener('pointerleave', function () { dragging = false; });
    }

    // Sticky bar -> jumps to the Releasit button/native form (whichever is active)
    var scrollBtn = wrap.querySelector('.nida-scroll-top');
    if (scrollBtn) scrollBtn.addEventListener('click', function () {
      if (cfg.CHECKOUT_APP === 'releasit' && releasitBtn) {
        releasitBtn.click();
      } else {
        wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    // Buyer counter ticking up
    var counterEl = wrap.querySelector('.nida-buyer-count');
    if (counterEl) {
      var count = cfg.BUYER_COUNT_START || 3000;
      var productName = counterEl.dataset.productName || '';
      setInterval(function () {
        if (Math.random() > 0.6) {
          count += 1;
          counterEl.textContent = count + ' ' + (cfg.BUYER_COUNT_LABEL_SUFFIX || 'personas han comprado hoy');
        }
      }, 8000);
    }

    // Countdown timer
    var countdownEl = wrap.querySelector('.nida-countdown');
    if (countdownEl) {
      if (!cfg.SHOW_COUNTDOWN) {
        countdownEl.style.display = 'none';
      } else {
        var minutesEl = countdownEl.querySelector('.nida-cd-min');
        var secondsEl = countdownEl.querySelector('.nida-cd-sec');
        var labelEl = countdownEl.querySelector('.nida-cd-label');
        if (labelEl) labelEl.textContent = cfg.COUNTDOWN_LABEL || '¡Oferta termina en!';
        var totalSeconds = (cfg.COUNTDOWN_MINUTES || 15) * 60;
        function tick() {
          if (totalSeconds <= 0) totalSeconds = (cfg.COUNTDOWN_MINUTES || 15) * 60;
          var m = Math.floor(totalSeconds / 60);
          var s = totalSeconds % 60;
          if (minutesEl) minutesEl.textContent = String(m).padStart(2, '0');
          if (secondsEl) secondsEl.textContent = String(s).padStart(2, '0');
          totalSeconds -= 1;
        }
        tick();
        setInterval(tick, 1000);
      }
    }

    // Marquee + social proof line text from config
    var marqueeEls = wrap.querySelectorAll('.nida-marquee-text');
    marqueeEls.forEach(function (el) { el.textContent = cfg.MARQUEE_TEXT || el.textContent; });
    var socialProofEl = wrap.querySelector('.nida-social-proof-line');
    if (socialProofEl && cfg.SOCIAL_PROOF_LINE) socialProofEl.textContent = cfg.SOCIAL_PROOF_LINE;
  });
})();
